import { Injectable } from '@angular/core';
import {
  CanLoad,
  Route,
  UrlSegment
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { HubService } from '~app/modules/custom-hub/services';
import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';

@Injectable({
  providedIn: 'root'
})
export class CustomHubGuard implements CanLoad {

  constructor(
    private router: HomepageNavigatorService,
    private hubService: HubService
  ) {
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    const slugSegment = segments[1];

    if (slugSegment?.path) {
      const pageName = slugSegment.path;
      return this.hubService.getCustomHubConfig(pageName)
        .pipe(
          switchMap(hub => {
            if (hub) {
              return of(true);
            } else {
              return this.router.navigateToHomepage();
            }
          }),
          catchError((err) => {
            return this.router.navigateToHomepage();
          })
        );
    }

    return this.router.navigateToHomepage();
  }
}
